<div class="spinner-wrapper" *ngIf="showLoader">
  <mat-spinner></mat-spinner>
</div>
<div class="container design-wrapper">
  <h2>Select Design</h2>
  <hr />
  <div class="breadcrumb">
    <ul class="d-flex align-items-center breadcrumb__list">
      <li routerLink="/home" class="breadcrumb__list__list-item">
        <a class="breadcrumb__list__list-item__link">Home</a>
      </li>
      <li class="breadcrumb__list__list-item">
        <a routerLink="/design" class="breadcrumb__list__list-item__link">Designs</a>
      </li>
    </ul>
  </div>
  <form action="">
    <div class="input-wrapper">
      <mat-form-field appearance="fill" class="d-flex search-field">
        <mat-icon>search</mat-icon>
        <input matInput [(ngModel)]="searchDesign" name="search" (input)="searchDesigns()" placeholder="Placeholder" />
      </mat-form-field>
    </div>
  </form>

  <div class="design-wrapper__item">
    <div class="d-flex flex-wrap">
      <div class="flex-grow-1 flex-column d-flex">
        <h2 class="design-wrapper__item__title">Name: {{ location?.subdivision_name }}</h2>
        <p class="design-wrapper__item__detail"><b>Id:</b> {{ location?.location_id }}</p>
        <p class="design-wrapper__item__detail"><b>Lot:</b> {{ location?.lot }}</p>
        <p class="design-wrapper__item__detail"><b>Street:</b> {{ location?.street_address }}</p>
        <p class="design-wrapper__item__detail"><b>City:</b>{{ location?.city }}</p>
        <div class="mt-auto">
          <button [routerLink]="['/locations']" mat-flat-button
            class="mt-auto w-auto me-3 view-design" color="accent">
            Select Other Location
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="design-wrapper__item" *ngFor="let design of designs">
    <div class="d-flex flex-wrap">
      <div class="flex-grow-1 flex-column d-flex">
        <h2 class="design-wrapper__item__title">{{ design.name }}</h2>
        <p class="design-wrapper__item__detail">{{ design.id }}</p>
        <div class="mt-auto d-flex">
          <div *ngIf="design.completesystems; else elseBlock">
            <button [routerLink]="['/confirm-location-design']" [queryParams]="{ id: design.id,location_id:location?.location_id}" mat-flat-button
            class="mt-auto me-3 system" color="primary">
            Select Design to assign
          </button>
          </div>
          <ng-template #elseBlock>     
        <button [routerLink]="['/design-systems']" [queryParams]="{ id: design.id }" mat-flat-button
        class="mt-auto me-3 system" color="warn">
        Finish The Systems
      </button>
          </ng-template>
          
          <button [routerLink]="['/design-systems']" [queryParams]="{ id: design.id }" mat-flat-button
            class="mt-auto me-3 view-design" color="accent">
            View Systems
          </button>
        </div>
      </div>
    </div>
  </div>
</div>